import { defineComponent as _defineComponent } from 'vue'
import { PromptEnum, useChatgptTranslateLazyQuery } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'Translate',
  props: {
  value: {
    type: String,
    required: true,
  },
  prompt: {
    type: String as PropType<PromptEnum>,
    default: PromptEnum.KpiTranslationPrompt,
  },
},
  emits: ['translate-done'],
  setup(__props, { emit }) {

const props = __props;





const {
  result,
  loading,
  load: translate,
  onResult,
} = useChatgptTranslateLazyQuery({
  input: {} as any,
})

onResult(() => {
  emitTranslation()
})

const emitTranslation = () => {
  if (result.value?.chatgptTranslate?.[0]?.translatedText) {
    emit('translate-done', result.value.chatgptTranslate[0].translatedText)
  }
}

const handleTranslate = async () => {
  await translate(null, {
    input: {
      inputText: props.value,
      targetLanguage: 'de',
    },
  })
  // If Apollo has a cached result, the above query won't fire and this will emit it immediately.
  emitTranslation()
}

return { __sfc: true,props, emit, result, loading, translate, onResult, emitTranslation, handleTranslate }
}

})